import FeaturesList from './FeaturesList';

export default FeaturesList;
